module.exports = __webpack_public_path__ + "static/media/14.45ba68fa.jpg";